import { useStore } from '@/hooks/useStore';
import { cn } from '@/utils/utils';
import { observer } from 'mobx-react-lite';
import { ReactNode, useMemo } from 'react';
import Header, { HeaderProps } from './Header';
import classNames from 'classnames';

interface ContainerBodyProps extends HeaderProps {
    children: ReactNode,
    showHeader: boolean,
    showFooter: boolean,
    showFooterMenu?: boolean,
    bodyClassname?: string
}

const headerHeightDefault = 5; // rem
const footerHeightDefault = 2.5; // rem

export default observer(function MyAccountContainerBody({
    children,
    showHeader,
    showFooter,
    showFooterMenu,
    headerMobileComponent,
    headerMobileComponentForGeneral,
    bodyClassname
}: ContainerBodyProps) {
    // store
    const {
        uiStore: { windowSize, devicesScreen }
    } = useStore();

    // state
    const minHeightContent = useMemo(() => {
        let heightHeader = 0, heightFooter = 0;

        if (showHeader) {
            heightHeader = headerHeightDefault;
        }

        if (showFooter) {
            heightFooter = footerHeightDefault;
        }

        return heightHeader + heightFooter;
    }, [showHeader, showFooter, devicesScreen, windowSize]);

    return (
        <>
            {/* Header */}
            {showHeader && (
                <Header
                    headerMobileComponent={headerMobileComponent}
                    headerMobileComponentForGeneral={headerMobileComponentForGeneral}
                />
            )}

            {/* Body */}
            <section className={cn(
                'bg-background-4',
                bodyClassname
            )}
            >
                <div
                    className={classNames(showHeader && 'point-940:mt-[80px] mt-[min(60px,15vw)]', 'container md:py-10 py-5 flex')}
                    style={{ minHeight: `calc(100vh - ${minHeightContent}rem)` }}
                >
                    <div className='flex-1 max-w-full'>
                        {children}
                    </div>
                </div>
            </section>

            {/* Footer */}
            {
                showFooter && (
                    <section className={cn(
                        'bg-background-4 h-[2.5rem]'
                    )}
                    />
                )
            }

        </>
    );
});
